import elementLangs from './config/element.lang.config'
import zhLang from './config/zh-CN'
import enLang from './config/en-US'
const messages = {
    zh_CN: Object.assign(zhLang, elementLangs['zh']),
    en_US: Object.assign(enLang, elementLangs['en']),
}

const localeI18n = {
    locale: 'zh_CN', // set locale
    fallbackLocale: 'en_US',
    messages // set locale messages
}

export default localeI18n
